import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import { FormattedMessage } from '@dbk/format';
import { Small } from '../text';

import styles from './abbreviated-notes.styles';

function AbbreviatedNotes({ visible }) {
  return visible && (
    <View style={styles.root}>
      <Small type="secondary">
        <FormattedMessage id={'app.abbreviated.notes'} />
      </Small>
    </View>
  );
}

AbbreviatedNotes.propTypes = {
  visible: PropTypes.bool,
};

AbbreviatedNotes.defaultProps = {
  visible: true,
};

export default AbbreviatedNotes;
